import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query"
import api from "services/api"
import { ICartPresubscription } from "./types"

export function useCart(
  memberId?: string,
  config?: UseQueryOptions<ICartPresubscription[]>
) {
  return useQuery<ICartPresubscription[]>(
    [
      "operation",
      "administration",
      "members",
      "portal",
      memberId,
      "cart",
    ],
    {
      enabled: !!memberId,
      ...config,
    }
  )
}

export function useAddEventsToCart(
  memberId: string,
  config?: UseMutationOptions<
    unknown,
    unknown,
    { events: string[] }
  >
) {
  const queryClient = useQueryClient()
  return useMutation<
    unknown,
    unknown,
    { events: string[] }
  >(
    (data) =>
      api.post(
        `operation/administration/members/portal/${memberId}/presubscriptions/events`,
        data
      ),
    {
      ...config,
      onSuccess(data, vars, context) {
        config?.onSuccess?.(data, vars, context)
        queryClient.invalidateQueries([
          "operation",
          "administration",
          "members",
          "portal",
          memberId,
          "cart",
        ])
        queryClient.invalidateQueries([
          "operation",
          "administration",
          "members",
          "portal",
          memberId,
          "events",
        ])
      },
    }
  )
}

export function useDeleteFromCart(
  memberId: string,
  config?: UseMutationOptions<
    unknown,
    unknown,
    { presubscription_id: string; apply_to_similar_events: boolean }
  >
) {
  const queryClient = useQueryClient()
  return useMutation<
    unknown,
    unknown,
    { presubscription_id: string; apply_to_similar_events: boolean }
  >(
    (data) =>
      api.delete(
        `operation/administration/members/portal/${memberId}/cart`,
        { data }
      ),
    {
      ...config,
      onSuccess(data, vars, context) {
        config?.onSuccess?.(data, vars, context)
        queryClient.invalidateQueries([
          "operation",
          "administration",
          "members",
          "portal",
          memberId,
          "cart",
        ])
      },
    }
  )
}

export function useConfirmCart(memberId: string, config?: UseMutationOptions) {
  const queryClient = useQueryClient()
  return useMutation(
    () =>
      api.post(
        `operation/administration/members/portal/${memberId}/cart/confirm`
      ),
    {
      ...config,
      onSuccess(data, vars, context) {
        config?.onSuccess?.(data, vars, context)
        queryClient.removeQueries([
          "operation",
          "administration",
          "members",
          "portal",
          memberId,
          "cart",
        ])
        queryClient.invalidateQueries([
          "operation",
          "administration",
          "members",
          "portal",
          memberId,
          "presubscriptions",
        ])
      },
    }
  )
}
